import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// Outdoor oak bench (visual only — sittable seats live on pavilion furniture).
// Seat runs along +z; sitters face +x; backrest sits on the rear (−x) edge of
// the seat slab (bottom flush with the seat top, no floating gap).
const build: (ctx: DecoBuildCtx) => void = ({ box, seed }) => {
  const wood = shade(0x8a6f4d, (rand(seed) - 0.5) * 0.1);
  const dk = shade(wood, -0.15);

  const len = 2.4;       // run length (z)
  const seatD = 0.68;    // seat depth (x) — front +x, back −x
  const seatH = 0.12;
  const seatTop = 0.62;
  const seatY = seatTop - seatH / 2;

  // Seat plank
  box(0, seatY, 0, seatD, seatH, len, wood);

  // Legs under each end
  const legW = 0.2;
  const legD = 0.28;
  const legH = seatTop - seatH;
  for (const sz of [-1, 1]) {
    box(
      0,
      legH / 2,
      sz * (len / 2 - 0.28),
      legD,
      legH,
      legW,
      dk,
    );
  }

  // Backrest: board standing on the rear edge of the seat (no gap).
  const backT = 0.1;     // thickness along x
  const backH = 0.58;
  // Outer face of back ≈ rear face of seat; board bottoms slightly into the
  // seat top so the join reads solid at low poly.
  const backX = -seatD / 2 + backT / 2;
  const backY = seatTop + backH / 2 - 0.02;
  box(backX, backY, 0, backT, backH, len * 0.94, wood);
};

export default build;
